<ul class="pt-3 pagination justify-content-center" *ngIf="searchComponent.results">
  <li class="page-item" [class.disabled]="searchComponent.results.first || loading" (click)="searchComponent.previous()">
    <a class="page-link">Précédente</a>
  </li>
  <li class="page-item disabled"><a class="page-link">Page {{ searchComponent.results.number + 1 }} / {{ searchComponent.results.totalPages }}</a></li>
  <li class="page-item" [class.disabled]="searchComponent.results.last || loading" (click)="searchComponent.next()">
    <a class="page-link">Suivante</a>
  </li>
</ul>